import { getDataWithPromise, handleAjaxError} from "./BaseDataFns";

export const getEschoolsUrlForSchool = (school_id) => {

  const url =  Globals.APIFolder + '/school/' + school_id + '/eschoolsUrl'  ;

  return getDataWithPromise(url, 'GET', {});
};

export const getSILinksForSchool = (school_id) =>
{
  const url = Globals.APIFolder + '/reference/silinks/' + school_id;

  return getDataWithPromise(url, 'GET', {});
}

/**
 *
 * @param school_id
 * @returns {Promise}
 */
export const getSALinksForSchool = (school_id) =>
{
  const url = Globals.APIFolder + '/reference/salinks/' + school_id;

  return getDataWithPromise(url, 'GET', {});
}
